import { ColorDynamic } from '@superdispatch/ui';
import { WebviewLayout } from 'shared/layout/WebviewLayout';
import { ShipperReportReasonSelector } from '../../core/shipper-profile/shipper-reporting/ShipperReportReasonSelector';
import {
  REPORT_REASONS_TITLE,
  ShipperRatingFormRestricted,
  ShipperReportingForm,
} from '../../core/shipper-profile/shipper-reporting/ShipperReportingDrawer';
import { useNavigate, useParams } from 'react-router-dom';
import { useShipperProfile } from 'shared/modules/shipper/LoadboardShipperAPI';
import { CircularProgress } from '@material-ui/core';
import { ShipperReportingConfirmation } from '../../core/shipper-profile/shipper-reporting/ShipperReportingConfirmation';
import {
  ExtendedReason,
  isRatingReportReason,
} from 'shared/modules/shipper/ShipperReportDTO';
import { useDocumentTitle } from 'shared/layout/DocumentTitle';
import { trackEvent } from 'shared/helpers/Analytics';
import { startCase } from 'es-toolkit/compat';

export function ShipperReportConfirmationScreen() {
  const navigate = useNavigate();

  useDocumentTitle('Report Shipper');

  return (
    <WebviewLayout backgroundColor={ColorDynamic.White}>
      <ShipperReportingConfirmation
        onFinish={() => {
          navigate(`../..`, { replace: true });
        }}
      />
    </WebviewLayout>
  );
}

export function ShipperReportingFormScreen() {
  const navigate = useNavigate();
  const { guid, reason } = useParams<{
    guid: string;
    reason: ExtendedReason;
  }>();

  const { data: shipperProfile } = useShipperProfile(guid);

  useDocumentTitle(reason ? REPORT_REASONS_TITLE[reason] : 'Report Shipper');

  return (
    <WebviewLayout backgroundColor={ColorDynamic.White}>
      {!shipperProfile || !reason ? (
        <CircularProgress />
      ) : isRatingReportReason(reason) ? (
        <ShipperRatingFormRestricted
          shipper={shipperProfile}
          reason={reason}
          onSubmitSuccess={() => {
            navigate('../confirmation', { replace: true });
          }}
        />
      ) : (
        <ShipperReportingForm
          shipper={shipperProfile}
          reason={reason}
          onSubmitSuccess={() => {
            navigate('../confirmation', { replace: true });
          }}
        />
      )}
    </WebviewLayout>
  );
}

export function ShipperReportingReasonSelectorScreen() {
  const navigate = useNavigate();
  useDocumentTitle('Report Shipper');
  return (
    <WebviewLayout backgroundColor={ColorDynamic.White}>
      <ShipperReportReasonSelector
        onReasonSelect={(reason) => {
          trackEvent(`Shipper Selected ${startCase(reason)} Reporting Reason`, {
            reason,
          });
          navigate(`../${reason}/report-form`);
        }}
      />
    </WebviewLayout>
  );
}
